// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyComponent__no-content-c9fa70 {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  margin-bottom: var(--header-height);
  padding: 0 20px;
  text-align: center;
}

.EmptyComponent__img-ef60b1 {
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/SelectContacts/Users/EmptyComponent/EmptyComponent.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AACF;;AACA;EACE,mBAAA;AAEF","sourcesContent":[".no-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  margin-bottom: var(--header-height);\n  padding: 0 20px;\n  text-align: center;\n}\n.img {\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-content": `EmptyComponent__no-content-c9fa70`,
	"noContent": `EmptyComponent__no-content-c9fa70`,
	"img": `EmptyComponent__img-ef60b1`
};
module.exports = ___CSS_LOADER_EXPORT___;
